module.exports = __webpack_public_path__ + "static/img/jjf.f04bf07.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jjf.png
// module id = WQhz
// module chunks = 1